import React from "react";
import DatePicker, { DateObject, toDateObject } from "react-multi-date-picker";
import { connect } from "react-redux";
import ShortcutPlugin from "./ShortcutPlugin";
import {updateGlobalFromTimeAndToTime} from "../../actions/analyticsDatePickerActions";
import {showToastForBackend} from "../../actions/toastActions";
import MaterialIcon from "../MaterialIcon";

class DatePickerRange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focusedInput: null,
            values: [
                toDateObject((this.props.showGlobal) ? (this.props.chart.fromTime !== null ? (this.props.chart.fromTime) : null) : (this.props.analyticsDatePicker.globalFromTime)),
                toDateObject((this.props.showGlobal) ? (this.props.chart.toTime !== null ? (this.props.chart.toTime) : null) : (this.props.analyticsDatePicker.globalToTime))
            ]
        };
        this.onDatesChange = this.onDatesChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
        this.onGlobalSelected = this.onGlobalSelected.bind(this);
        this.onPresetDateSelected = this.onPresetDateSelected.bind(this);
        this.updateTimeProperties = this.updateTimeProperties.bind(this);
    }
    
    updateTimeProperties(start, end, presetDate) {
        //If datepicker is the global datepicker, update global fromTime and toTime
        if (!this.props.showGlobal) {
            this.props.updateGlobalFromTimeAndToTime(start.valueOf(), end.valueOf(), presetDate);
        }
        //If datepicker is not the global datepicker and chart uses the global datepicker's parameters
        if (this.props.showGlobal && this.props.chart.useGlobal) {
            this.props.changeProperty(this.props.chart.id, ['fromTime', 'toTime', 'useGlobal', 'presetDate'], [start.valueOf(), end.valueOf(), !this.props.chart.useGlobal, presetDate]);
        }
        //If datepicker is not the global datepicker and chart's datepicker has been selected
        if (this.props.showGlobal && !this.props.chart.useGlobal) {
            this.props.changeProperty(this.props.chart.id, ['fromTime', 'toTime', 'presetDate'], [start.valueOf(), end.valueOf(), presetDate]);
        }
    }

    getDates() {
        return this.props.chart && this.props.chart.useGlobal ? [toDateObject(this.props.analyticsDatePicker.globalFromTime), toDateObject(this.props.analyticsDatePicker.globalToTime)] : this.state.values;
    }

    onDatesChange(range) {
        this.setState({
            values: range
        })
        if (range[0] && range[1]) {
            this.updateTimeProperties(range[0].toDate(), range[1].toDate(), "CUSTOM");
        }
    }

    onFocusChange(focusedInput) {
        this.setState({focusedInput});
        if (!focusedInput) {
            this.current.closeCalendar();
        }
    }

    onPresetDateSelected(start, end, presetDate) {
        const update = {...this.state}
        update.values = [toDateObject(start.toDate()), toDateObject(end.toDate())];
        this.setState({...update});
        this.updateTimeProperties(start, end, presetDate);
    }

    onGlobalSelected() {
        this.setState({
            values: [
                toDateObject(this.props.analyticsDatePicker.globalFromTime),
                toDateObject(this.props.analyticsDatePicker.globalToTime)
            ]
        })
        if (!this.props.chart.useGlobal) {
            this.props.changeProperty(this.props.chart.id, ['useGlobal', 'fromTime', 'toTime', 'presetDate'], [true, this.props.analyticsDatePicker.fromTime, this.props.analyticsDatePicker.toTime, this.props.analyticsDatePicker.presetDate]);
        }
    }

    render() {
        return (
            <div
                className={"date-range-picker " + ((!this.props.showGlobal || (!this.props.chart.useGlobal && this.state.startDate !== null && this.state.endDate !== null)) ? "" : "global-selected") +(this.props.readOnly ? " disabled" : "")}>
            <DatePicker
                ref={this}
                monthYearSeparator="&nbsp;"
                disableYearPicker={true}
                disableMonthPicker={true}
                range
                value={this.getDates()}
                numberOfMonths = {2}
                format="DD/MM/YYYY"
                weekDays={["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]}
                dateSeparator = "&rarr;"
                currentDate = {new DateObject().subtract(1, 'month')}
                maxDate = {new DateObject()}
                readOnly={this.props.readOnly}
                onChange = {(e) => this.onDatesChange(e)}
                onFocusChange = {(e) => this.onFocusChange(e)}
                plugins = {[<ShortcutPlugin 
                                key="static" 
                                position="right" 
                                onPresetDateSelected={(start, end, preset) => this.onPresetDateSelected(start, end, preset)}
                                onGlobalSelected={() => this.onGlobalSelected()}
                                onFocusChange={(e) => this.onFocusChange(e)}
                                {...this.props}/>]}
                renderButton={(direction, handleClick) => (
                    <button onClick={handleClick}>
                        {direction === "right" ? ">" : "<"}
                    </button>
                    )}
            />
            <div className={"date-picker-icon" + (this.props.readOnly ? " disabled" : "")}>
                <MaterialIcon icon="calendar_today" size={24} onClick={() => this.current.openCalendar()}/>
            </div>
        </div>
    )}
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        analyticsDatePicker: state.analyticsDatePicker
    }
}

export default connect(mapStateToProps, {updateGlobalFromTimeAndToTime, showToastForBackend})(DatePickerRange);
